export enum VerificationType {
  'FAILED' = 'FAILED',
  'WARNING' = 'WARNING',
  'VERIFIED' = 'VERIFIED',
}

export enum ClaimedStatusType {
  'SELF_REPORTED' =  'SELF_REPORTED',
  'MAPPED' =  'MAPPED',
  'VERIFIED' =  'VERIFIED',
}

export enum ProcessStatus {
  UPCOMING = 1,
  UPDATED = 2,
  MISSED = 3
}

export enum Grade {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  NONE = 'NONE'
}

export interface IGaugeChartDetailData {
  reduce_increase: number
  grade: Grade | null,
  recorded: number
}

export interface IGaugeChartData {
  water: IGaugeChartDetailData
  carbon: IGaugeChartDetailData
  energy: IGaugeChartDetailData
}

export enum IGaugeChartKey {
  WATER = 'water',
  CARBON = 'carbon',
  ENERGY = 'energy'
}

export interface ITabs {
  value: string | number,
  display: string
  icon?: any
  className?: string
}

export interface IProcessMaps {
  marker: {
    lat: string,
    lng: string
  },
  name: string
}

export enum Message {
  NEUTRAL = 'neutral',
  INFO = 'error',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATETIME_FORMAT = 'YYYY-MM-DD H:MM A';

export enum MEDIA_TYPE {
  COMPANY_LOGO = "COMPANY_LOGO",
  PRODUCT = "PRODUCT",
  PROCESS_IMAGE = "PROCESS_IMAGE",
  PROCESS_VIDEO = "PROCESS_VIDEO",
  PROCESS_CERTIFICATE = "PROCESS_CERTIFICATE",
  PRODUCTS_CSV = "PRODUCTS_CSV",
  TEMPLATE = "TEMPLATE",
}

export enum QUESTION_TYPE {
  DECIMAL = "DECIMAL",
  INTEGER = "INTEGER",
  STRING = "STRING",
  DATE_PICKER = "DATE_PICKER",
  DATETIME_PICKER = "DATETIME_PICKER",
  FILE_UPLOAD = "FILE_UPLOAD",
  PERCENTAGE = "PERCENTAGE",
  DROPDOWNLIST = "DROPDOWNLIST"
}

export enum USER_ACTION {
  DEFAULT = 'DEFAULT',
  VIEW = 'VIEW',
  DELETE = 'DELETE',
  EDIT = "EDIT",
  CREATE = "CREATE",
  RESTORE = "RESTORE",
  ENABLE = "ACTIVE",
  DISABLE = "DISABLE",
  SET_AS_ADMIN = "SET_AS_ADMIN",
  REVOKE_ADMIN = "REVOKE_ADMIN",
  REVOKE_PARTNERSHIP = "REVOKE_PARTNERSHIP",
  BUY_SCANNER = "BUY_SCANNER",
  TRANSFER_SCANNER = "TRANSFER_SCANNER",
  INVITE_USERS = "INVITE_USERS",
  BUY_AUDIT_CREDITS = "BUY_AUDIT_CREDITS",
  INVITE_PARTNERS = "INVITE_PARTNERS",
  READ = "READ",
  UPDATE = "UPDATE",
  SHARE = "SHARE",
  AUDIT = "AUDIT",
}

export interface IREACT_SELECT {
  isDisabled: boolean
  isLoading: boolean
  isClearable: boolean
  isSearchable: boolean
  list: Array<any>
  selected: any
}

export enum E_ProcessClaimedStatus {
  CLAIMED = "CLAIMED",
  UNCLAIMED = "UNCLAIMED",
  VERIFIED = "VERIFIED",
  SELF_REPORTED = "SELF_REPORTED",
  DISPUTED = "DISPUTED",
}
